import { IPayload } from '../../models/Global'
import {
  IGroup,
  IGetGroupsParams,
  IPutGroupParams,
  IPostGroupParams,
} from '../../models/Group'
import { AxiosService } from '../config/config'
import { Endpoints } from '../config/endpoints'

export class GroupsApi {
  constructor(private axios: AxiosService) {}

  getGroups = async (params?: IGetGroupsParams) => {
    const response = await this.axios.get<IPayload<IGroup[]>>(
      Endpoints.getGroups,
      params,
    )
    return response
  }

  getGroup = async (id: number, params?: IGetGroupsParams) => {
    const response = await this.axios.get<IPayload<IGroup>>(
      Endpoints.getGroup(id),
      params,
    )
    return response
  }

  postGroup = async (params: IPostGroupParams) => {
    const response = await this.axios.post<IPayload<IGroup>>(
      Endpoints.postGroup,
      params,
    )
    return response
  }

  putGroup = async (id: number, params?: IPutGroupParams) => {
    const response = await this.axios.put<IPayload<IGroup>>(
      Endpoints.putGroup(id),
      params,
    )
    return response
  }

  deleteGroup = async (id: number) => {
    const response = await this.axios.delete<{}>(Endpoints.deleteGroup(id))
    return response
  }
}
